export interface LocationData {
  lat: number;
  lng: number;
  address: string;
  accuracy?: number;
}

export interface LocationOptions {
  addressFormat?: 'full' | 'short'; // 'short' untuk mereturn Kelurahan & Kota
}

const tryGetPosition = (highAccuracy: boolean): Promise<GeolocationPosition> =>
  new Promise((resolve, reject) =>
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: highAccuracy,
      timeout: 10000,
      maximumAge: 30000,
    })
  );

export const getCurrentLocation = async (options?: LocationOptions): Promise<LocationData> => {
  if (!navigator.geolocation) {
    throw new Error('Geolocation is not supported by this browser.');
  }

  let position: GeolocationPosition;
  try {
    position = await tryGetPosition(true);
  } catch {
    // Fallback ke network location jika GPS hardware tidak tersedia (emulator, indoor, dll)
    position = await tryGetPosition(false);
  }

  const lat = position.coords.latitude;
  const lng = position.coords.longitude;
  let address = '';

  try {
    const providerUrl = process.env.REACT_APP_GEOCODE_URL || 'https://nominatim.openstreetmap.org/reverse';
    const apiKey = process.env.REACT_APP_GEOCODE_KEY || '';

    let url = `${providerUrl}?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`;
    if (apiKey) url += `&key=${apiKey}`;

    const response = await fetch(url);
    const data = await response.json();

    if (data && data.address) {
      if (options?.addressFormat === 'short') {
        const village = data.address.village || data.address.suburb || data.address.neighbourhood || '';
        const city = data.address.city || data.address.town || data.address.city_district || data.address.county || '';
        address = [village, city].filter(Boolean).join(', ');
      }
    }

    if (!address && data && data.display_name) {
      address = data.display_name;
    }
  } catch (error) {
    console.error("Failed to fetch address", error);
  }

  return { lat, lng, address, accuracy: position.coords.accuracy };
};